// Revoking an object URL tears down the blob behind it. The download itself is
// started synchronously by click(), but browsers do not all finish reading the
// blob within that same task, and a revoke in the click's own `finally` has
// been reported to abort the download on Firefox and Safari. Deferring to a
// later task costs one blob held for a second and removes the race entirely.
//
// Chromium tolerates the synchronous form, which is why this was never seen
// locally — the delay is deliberate insurance, not a fix for a reproduction.
const REVOKE_DELAY_MS = 1_000;

export function downloadBlob(blob: Blob, filename: string) {
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = objectUrl;
  link.download = filename;
  link.style.display = 'none';

  document.body.appendChild(link);
  try {
    link.click();
  } finally {
    link.remove();
    setTimeout(() => URL.revokeObjectURL(objectUrl), REVOKE_DELAY_MS);
  }
}

export async function downloadFileFromUrl(url: string, filename: string) {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Download failed with HTTP ${response.status}`);
  }

  const blob = await response.blob();
  downloadBlob(blob, filename);
}
